import { useTranslation } from "react-i18next";
import { useGetDialogsQuery } from "../../dialogs/dialogsSlice";
import useCreateDialog from "../../dialogs/hooks/useCreateDialog";

const useProblemCard = () => {
  const { t } = useTranslation();
  const dialogs = useGetDialogsQuery();
  const { postNewDialog, creatingDialog } = useCreateDialog();

  const dialogsArray = dialogs?.data || [];
  const reversedArray = [...dialogsArray]
    ?.filter((item) => {
      return item.topic !== "AUTO" && item.topic !== "Solve the next problem";
    })
    .reverse();

  return {
    onCreateDialog: postNewDialog,
    buttonCaption: t("chat.solveNextProblem"),
    creatingDialog,
    dialogs: reversedArray,
    dialogsLoading: dialogs?.isLoading,
  };
};

export default useProblemCard;
